<template>
  <Teleport to="body">
    <Transition name="status-modal-overlay">
      <div
        v-if="show"
        class="error-modal-overlay"
        role="presentation"
        @click.self="closeModal"
      >
        <Transition name="status-modal-panel" appear>
          <div
            v-if="show"
            class="error-modal"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="error-modal-title"
            @click.stop
          >
            <header class="error-modal-header">
              <h3 id="error-modal-title">{{ title }}</h3>
              <button
                type="button"
                class="error-modal-close"
                aria-label="Close"
                @click="closeModal"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </header>
            <div class="error-modal-body">
              <div class="status-modal-body-content">
                <div class="status-modal-icon-wrap">
                  <span class="status-modal-icon-ring status-modal-icon-ring--error" aria-hidden="true"></span>
                  <div class="status-modal-icon status-modal-icon--error" aria-hidden="true">
                    <i class="bi bi-x-circle-fill"></i>
                  </div>
                </div>
                <div
                  v-if="parsedMessageLines.length"
                  class="status-modal-message status-modal-message--error"
                >
                  <p
                    v-for="(line, index) in parsedMessageLines"
                    :key="'msg-' + index"
                    class="status-modal-message-line"
                    :style="{ animationDelay: `${0.14 + index * 0.07}s` }"
                  >
                    <template v-for="(part, pIndex) in line" :key="'part-' + index + '-' + pIndex">
                      <button
                        v-if="part.link"
                        type="button"
                        class="error-modal-nav-link"
                        @click="onLinkClick(part.text)"
                      >{{ part.text }}</button>
                      <span v-else>{{ part.text }}</span>
                    </template>
                  </p>
                </div>
              </div>
            </div>
            <footer class="error-modal-footer">
              <button
                v-if="actionButtonText"
                type="button"
                class="status-modal-btn status-modal-btn--primary"
                @click="onLinkClick(actionButtonText)"
              >{{ actionButtonText }}</button>
              <button
                v-else
                type="button"
                class="status-modal-btn status-modal-btn--primary"
                @click="closeModal"
              >{{ buttonText }}</button>
            </footer>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import './ErrorModal.css';

export default {
  name: 'ErrorModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Error',
    },
    message: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'OK',
    },
    /** When set, replaces the OK button with one that emits `action` instead of `close`. */
    actionButtonText: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'action'],
  computed: {
    parsedMessageLines() {
      return this.splitMessageLines(this.message).map((line) => this.parseLineParts(line));
    },
  },
  methods: {
    splitMessageLines(text) {
      if (!text || !String(text).trim()) return [];
      const lines = String(text)
        .split('\n')
        .map((line) => line.trim())
        .filter(Boolean);
      return lines.length ? lines : [String(text).trim()];
    },
    /** Supports [[Clickable Label]] markers for in-message navigation links. */
    parseLineParts(line) {
      const source = String(line || '');
      const parts = [];
      const re = /\[\[(.+?)\]\]/g;
      let lastIndex = 0;
      let match = re.exec(source);
      while (match) {
        if (match.index > lastIndex) {
          parts.push({ text: source.slice(lastIndex, match.index), link: false });
        }
        parts.push({ text: match[1], link: true });
        lastIndex = match.index + match[0].length;
        match = re.exec(source);
      }
      if (lastIndex < source.length) {
        parts.push({ text: source.slice(lastIndex), link: false });
      }
      return parts.length ? parts : [{ text: source, link: false }];
    },
    onLinkClick(label) {
      this.$emit('action', label);
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
